var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "system-reports" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("Requests")) + " and Bookings")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-10" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("selectize", {
                  staticClass: "selectize selectize-single",
                  attrs: {
                    name: "data_type",
                    "disable-delete": true,
                    options: _vm.reportDataTypeOptions,
                  },
                  model: {
                    value: _vm.report.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.report, "type", $$v)
                    },
                    expression: "report.type",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.selectedReport && _vm.selectedReport.passwordRequired
          ? _c("div", { staticClass: "row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-10" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.report.password,
                        expression: "report.password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "password", name: "password" },
                    domProps: { value: _vm.report.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.report, "password", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedReport && _vm.selectedReport.datePicker
          ? _c("div", { staticClass: "row" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-8" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("flatpickr", {
                        ref: "date",
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.flatPickerDateConfig,
                          name: "date_range",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("p", [
                      _vm._v(
                        "If you do not select any regions, the report will default to your region"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "sr-only" }, [_vm._v("Region")]),
                    _vm._v(" "),
                    _c("selectize", {
                      ref: "regions",
                      staticClass: "selectize selectize-multiple",
                      attrs: {
                        multiple: "",
                        name: "region",
                        placeholder: "Region",
                        options: _vm.regionOptions,
                      },
                      model: {
                        value: _vm.report.selectedRegions,
                        callback: function ($$v) {
                          _vm.$set(_vm.report, "selectedRegions", $$v)
                        },
                        expression: "report.selectedRegions",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-2 pull-right" },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-block btn-dark",
                  attrs: { click: _vm.handleRunReportCallback },
                },
                [_vm._v("\n            Run\n          ")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "margin-20" }),
        _vm._v(" "),
        !_vm.$vlastMode
          ? _c(
              "div",
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-block btn-dark",
                    attrs: { click: _vm.handlePickFirstFile },
                  },
                  [_vm._v("\n          Process First File\n        ")]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput1",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", multiple: "" },
                  on: { change: this.handleUploadFirstFile },
                }),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-block btn-dark",
                    attrs: { click: _vm.handlePickSecondFile },
                  },
                  [_vm._v("\n          Process Second File\n        ")]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput2",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", multiple: "" },
                  on: { change: this.handleUploadSecondFile },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Reports")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-2" }, [
      _c("h3", [_vm._v("Data type:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-2" }, [
      _c("h3", [_vm._v("Password:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-2" }, [
      _c("h3", [_vm._v("Date range:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-toggle": "" } },
      [_c("i", { staticClass: "fa fa-calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-clear": "" } },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }